<template>
	<div class="app-sidebar bg-white rounded-2">
		<nav :class="{ 'sidebar-collapsed': collapsed }">
			<!-- Logo / Brand -->
			<div class="logo text-center fixed-logo">
				<div class="logo-content" v-show="!collapsed">
					<h3 class="logo-text">Town Web</h3>
					<p class="logo-text-sub">Onboarding</p>
				</div>
				<!-- Panel-left close/open icon (same as Juniper sidebar) -->
				<svg
					viewBox="0 0 18 18"
					class="sidebar-toggle-icon d-none d-md-block"
					role="button"
					tabindex="0"
					:aria-label="collapsed ? 'Expand Sidebar' : 'Collapse Sidebar'"
					@click.stop="toggleCollapsed"
					@keydown.enter.stop.prevent="toggleCollapsed"
					@keydown.space.stop.prevent="toggleCollapsed"
				>
					<title>{{ collapsed ? 'Expand Sidebar' : 'Collapse Sidebar' }}</title>
					<rect x="2.5" y="3.5" width="13" height="11" rx="2.25" fill="none" stroke="currentColor" stroke-width="1.4" />
					<line :x1="collapsed ? 12 : 6" y1="3.5" :x2="collapsed ? 12 : 6" y2="14.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
				</svg>
			</div>

			<!-- Scrollable nav -->
			<div class="scrollable-nav">
				<ul class="list-unstyled mb-0 juniper-nav-list">
					<li v-for="item in navItems" :key="item.path">
						<router-link
							class="btn juniper-nav-item"
							:class="{ 'router-link-exact-active router-link-active': isItemActive(item) }"
							:to="item.path"
						>
							<font-awesome-icon :icon="item.iconRef" class="juniper-nav-icon" />
							<span v-show="!collapsed" class="juniper-nav-label">{{ item.label }}</span>
							<span v-if="item.badge !== null && item.badge !== undefined && !collapsed" class="badge juniper-count-badge ms-auto">{{ item.badge }}</span>
						</router-link>
					</li>
				</ul>
			</div>

			<!-- Back to MC2 — flush with sidebar border -->
			<router-link class="btn btn-primary w-100 juniper-back-btn" to="/">
				<font-awesome-icon :icon="['fas', 'arrow-left']" :class="collapsed ? '' : 'me-2'" />
				<span v-if="!collapsed">Back to MC2</span>
			</router-link>
		</nav>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import restApi from '@/api'

const STORAGE_KEY = 'onboarding-sidebar-collapsed'

export default {
	name: 'OnboardingSidebar',
	data() {
		return {
			collapsed: localStorage.getItem(STORAGE_KEY) === 'true',
			totalOnboardings: null,
		}
	},
	computed: {
		...mapState(['token', 'authUser']),
		...mapGetters(['isAuth']),
		navItems() {
			return [
				{
					label: 'Dashboard',
					path: '/onboarding',
					iconRef: ['fas', 'house-user'],
					match: p => p === '/onboarding',
				},
				{
					label: 'Onboardings',
					path: '/onboarding/list',
					iconRef: ['fas', 'list'],
					match: p => p.includes('/onboarding/list'),
					badge: this.totalOnboardings,
				},
				{
					label: 'Settings',
					path: '/onboarding/options',
					iconRef: ['fas', 'cog'],
					match: p => p.includes('/onboarding/options'),
				},
			]
		},
	},
	created() {
		this.$emit('toggle', this.collapsed)
		this.loadOnboardingCount()
		this.$root.$on('onboarding-created', this.loadOnboardingCount)
	},
	beforeDestroy() {
		this.$root.$off('onboarding-created', this.loadOnboardingCount)
	},
	methods: {
		toggleCollapsed() {
			this.collapsed = !this.collapsed
			localStorage.setItem(STORAGE_KEY, this.collapsed)
			this.$emit('toggle', this.collapsed)
		},
		loadOnboardingCount() {
			// Paginated endpoint carries the total count
			restApi
				.get('/onboarding')
				.then(({ data }) => {
					this.totalOnboardings = data.total || 0
				})
				.catch(() => {})
		},
		isItemActive(item) {
			if (typeof item.match !== 'function') return false
			return item.match(this.$route.path)
		},
	},
}
</script>

